module.exports = __webpack_public_path__ + "assets/202509252035/img/Jeffrey.693b80d7.jpg";